import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M11 22h-.3c-.4-.2-.7-.6-.7-1v-6H6c-.4 0-.7-.2-.9-.5-.2-.3-.2-.7 0-1l7-11c.3-.4.8-.6 1.2-.5.4.2.7.6.7 1v6h4c.4 0 .7.2.9.5.2.3.2.7 0 1l-7 11c-.2.3-.6.5-.9.5Zm-3.2-9H11c.6 0 1 .4 1 1v3.6l4.2-6.6H13c-.6 0-1-.4-1-1V6.4L7.8 13Z" />,
  'Lightning'
)
